import { useQuery } from '@tanstack/react-query';
import ms from 'ms';

import { Loader } from '@hivebrite/design-system/Loader';

import MentoringApp from 'hb-react/frontoffice/apps/Mentoring';
import PageNotFound from 'hb-react/frontoffice/apps/Mentoring/pages/PageNotFound';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const TopicMentoringContainer = () => {
  const topicContext = useTopicContext();

  const {
    data: { topic } = {},
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['topic', topicContext.topicId],
    queryFn: () =>
      axios
        .get(Routes.topics_topic_path(topicContext.topicId))
        .then(({ data }) => data),
    gcTime: ms('5m'),
  });

  if (isLoading) {
    return <Loader size={40} />;
  }

  if (isError) {
    return <PageNotFound />;
  }

  return <MentoringApp disabledAccess={!topic?.followed} />;
};

export default TopicMentoringContainer;
